/**
 * HeaderStrip — franja de identidad aduanera de la encomienda en Producción.
 *
 * Decisiones de diseño:
 * - SOLO LECTURA por doctrina (principio 18 de verificación y brief): registro,
 *   fecha, aduana y gestor vienen de customs_config — el operador jamás los
 *   edita aquí. No hay inputs, no hay hover de edición: texto plano.
 * - Los pares label/valor imitan el bloque de información del Anexo PDF
 *   (generateAnexoPDF.js) para que el operador reconozca el destino final de
 *   estos datos.
 * - Etiquetas en var(--text-secondary), valores en var(--text-main): jerarquía
 *   sin carga visual extra. Separadores decorativos ocultos a lectores de pantalla.
 */
import { Landmark } from 'lucide-react';

const PAR = ({ etiqueta, valor }) => (
  <div className="flex items-baseline gap-1.5 whitespace-nowrap">
    <span className="text-[11px]" style={{ color: 'var(--text-secondary)' }}>
      {etiqueta}
    </span>
    <span className="text-xs font-semibold" style={{ color: 'var(--text-main)' }}>
      {valor || '—'}
    </span>
  </div>
);

const HeaderStrip = ({ snapshot = {}, fecha }) => (
  <div
    className="flex flex-wrap items-center gap-x-4 gap-y-1.5 rounded-lg border px-3 py-2.5"
    style={{ background: 'var(--bg)', borderColor: 'var(--border)' }}
    aria-label="Datos de aduana de la encomienda (solo lectura)"
  >
    <Landmark size={14} aria-hidden="true" style={{ color: 'var(--text-tertiary)' }} />
    <PAR etiqueta="No. de Registro:" valor={snapshot.registro_prefix} />
    <span aria-hidden="true" style={{ color: 'var(--border-hover)' }}>·</span>
    <PAR etiqueta="Fecha:" valor={fecha} />
    <span aria-hidden="true" style={{ color: 'var(--border-hover)' }}>·</span>
    <PAR etiqueta="Código de Aduana:" valor={snapshot.aduana_code} />
    <span aria-hidden="true" style={{ color: 'var(--border-hover)' }}>·</span>
    <PAR etiqueta="Código de Gestor:" valor={snapshot.gestor_code} />
    <span aria-hidden="true" style={{ color: 'var(--border-hover)' }}>·</span>
    <PAR etiqueta="Gestor:" valor={snapshot.gestor_name} />
  </div>
);

export default HeaderStrip;

/*
Ejemplo de uso:
  <HeaderStrip
    snapshot={draft.customs_config_snapshot}
    fecha="30/07/2026"
  />
*/
